import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { RadioGroup, Text, Box, Tooltip } from '@nerdwallet/currency';

import { ENTITY_NAME, RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  BedrockInterface,
  INPUT_TRACKING_TYPES,
} from '../../../../lib/utils';
import { TAX_FILING_STATUS_OPTIONS } from '../shared/constants';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const TaxFilingStatusInput: React.FC<RentVsBuyInput> = ({
  value,
  dispatch,
  label = '',
  tooltip = '',
  analytics,
  className,
}) => {
  const segmentAbstract = useAnalytics();
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'tax_filing_status',
        field_value: e.target.value,
        field: 'Tax Filing Status',
        field_type: 'radio',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'taxFilingStatus',
      calculator: RENT_VS_BUY,
      validate: false,
    });
  };

  return (
    <Box>
      <Text size="small">
        {label}
        <Tooltip
          placement="top"
          content={tooltip}
          analytics={{
            entityName: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            eventType: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            payload: {
              additional_attributes: {
                help_button_location: 'taxFilingStatus',
              },
            },
          }}
        />
      </Text>
      <RadioGroup
        value={value}
        options={TAX_FILING_STATUS_OPTIONS}
        onChange={onInputChange}
        inline
        className={className}
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  placeholder: state?.rentvsbuyCalculator?.manualInputs?.taxFilingStatus,
  value: state?.rentvsbuyCalculator?.inputs?.taxFilingStatus,
  errorMessage: state?.validations?.taxFilingStatus?.[0],
});

export default connect(mapStateToProps)(TaxFilingStatusInput);
